import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import { encryptAES, decryptAES } from "./cryptoUtils";
import { getApgJWTEqoute } from './getAppJWTEqoute'

const BASE_URL = process.env.REACT_APP_API_BASE_URLE;

// ✅ Custom axios instance
const apiClient4 = axios.create({
 baseURL: BASE_URL,
 headers: {
        "Content-Type": "text/xml; charset=utf-8",
        "SOAPAction": "http://tempuri.org/GenerateEBIDigitalPDF",
 },
 withCredentials: false,
});
// ✅ REQUEST INTERCEPTOR
apiClient4.interceptors.request.use(async (config) => {
const user_id = localStorage.getItem('user_id'); 
 
 
    try{
      const token = await getApgJWTEqoute();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (err) {
      console.error('Error fetching apg jwt token:', err);
    }

 return config;
}, (error) => Promise.reject(error));
// ✅ RESPONSE INTERCEPTOR
// RESPONSE INTERCEPTOR (simple + safe)
apiClient4.interceptors.response.use(
  (response) => {
    // 1) Pick token from body
    const token = response.data?.token;
    if (token) {
      localStorage.setItem("app_jwt_client4", token);
      // 2) Decode only if it's a real JWT
      if (token.split(".").length === 3) {
        try {
          const decoded = jwtDecode(token);
          if (decoded?.exp) {
            localStorage.setItem("app_jwt_expiry_client4", decoded.exp * 1000);
          }
        } catch (err) {
          console.warn("JWT decode skipped (invalid/opaque token):", err);
        }
      } else {
        // Apigee opaque tokens, skip decode
        console.warn("Token is not a standard JWT, skipping decode:", token);
      }
    }
    // 3) Decrypt wrapped responses (if any)
    if (response.data?.encryptedResponse) {
      try {
        const decrypted = decryptAES(response.data.encryptedResponse);
        response.data = JSON.parse(decrypted);
      } catch (err) {
        console.error("Response decrypt error:", err);
      }
    }
    return response;
  },
  (error) => Promise.reject(error)
 );

export const generateKey = async (userId) => {
  const res = await apiClient4.post(`${BASE_URL}/biu-nova/nova/generate/key`, { user_id: userId });
  return res.data.key; // "<encUser>|<encKey>"
 };
 // Send the combined key back to link USERID to KEY_VALUE
 export const updateUserIdSSO = async (combinedKey,agentId) => {
    console.log("this is the request", { key: combinedKey.split('|')[1], agentId:agentId })
  const res = await apiClient4.post(`${BASE_URL}/biu-nova/liva/sso-jwt`, { key: combinedKey.split('|')[1], agentId:agentId });
  return res.data; 
 };
 
export default apiClient4;

